import type { IAttentionPartnerOwners } from '../../../model/selectors/selectCockpitAttentionLevel'

/**
 * How many PBMs stand behind a set of partners. A partner can have a PBM per offering and a PBM
 * owns many partners, so the count is of distinct people rather than of assignments.
 */
export const countAttentionPbms = (
  partnerIds: string[],
  ownersByPartner: Map<string, IAttentionPartnerOwners>
): number =>
  new Set(
    partnerIds.flatMap((partnerId) =>
      (ownersByPartner.get(partnerId)?.pbms ?? []).map(({ ownerId }) => ownerId)
    )
  ).size
